import Vue from 'vue';
import EventBus from './../../event-bus';
import { $router } from '@/main';
import store from '@/store';

// When the request succeeds
const success = (response) => {
  // @ts-ignore
  EventBus.ToastEvent.emitGlobalSuccess('You have been logged out', true, 5000);
  store.dispatch('Auth/logout', response).then(() => {
    $router.push({
      name: 'login',
    });
  });
};

// When the request fails
const failed = (error) => {
  // @ts-ignore
  EventBus.ToastEvent.emitGlobalSuccess('You have been logged out', true, 5000);
  store.dispatch('Auth/logout', error.data).then(() => {
    $router.push({
      name: 'login',
    });
  });
};

export default () => {
  Vue.prototype.$http.delete('/auth').then((response) => {
    success(response.data);
  }).catch((error) => {
    failed(error.response);
  });
};
